var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPresentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.1H15v-4h-4.5v4zm-5.5 0h4.5v-4H5v4zm5.5-5h5v-2h-5v2zm-6 0h5v-2h-5v2zm4.5-7v.836l-.586-.586H7v1.414l.336.336H7l-1 1 1 1h6.5l1-1-1-1h-.836L13 5.764V4.35h-1.414L11 4.936V4.1l-1-1-1 1z",
    fill: "#00B83E"
  })));
}

export default SvgPresentIcon;